import api from "../config/api";

export const getAllAdvance = async () => {
  const response = await api.get("/advance/");
  return response.data;
};
export const getAdvanceBalanceAll = async () => {
  const response = await api.get("/advance/?balance=1");
  return response.data;
}
export const getAdvanceById = async (id) => {
  const response = await api.get(`/advance/?id=${id}`);
  return response.data;
};

export const getAdvanceByVendorId = async (vendor_id) => {
  const response = await api.get(`/advance/?vendor_id=${vendor_id}`);
  return response.data;
};

export const saveAdvance = async (data) => {
  const response = await api.post(`/advance/`, data, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const deleteAdvance = async (id) => {
  const response = await api.delete(`/advance/?id=${id}`);
  return response.data;
};
